import type { Translations } from './translation';

const translations: Translations = {
	ticket: 'Ticket',
	ticketOptions: 'Ticket Options',
	includedInTicket: 'Included in ticket',
	journeyDetails: 'Journey Details',
	transfers: 'transfers',
	walk: 'Walk',
	bike: 'Bike',
	cargoBike: 'Cargo bike',
	scooterStanding: 'Standing kick scooter',
	scooterSeated: 'Seated kick scooter',
	car: 'Car',
	taxi: 'Taxi',
	moped: 'Moped',
	unknownVehicleType: 'Unknown vehicle type',
	electricAssist: 'Electric motor assist',
	electric: 'Electric',
	combustion: 'Combustion',
	combustionDiesel: 'Diesel',
	hybrid: 'Hybrid',
	plugInHybrid: 'Plug-in hybrid',
	hydrogenFuelCell: 'Hydrogen fuel cell',
	from: 'From',
	to: 'To',
	viaStop: 'Via stop',
	viaStops: 'Via stops',
	addViaStop: 'Add via stop',
	removeViaStop: 'Remove via stop',
	viaStayDuration: 'Minimum stay',
	position: 'Position',
	arrival: 'Arrival',
	departure: 'Departure',
	connections: 'Connections',
	duration: 'Duration',
	arrivals: 'Arrivals',
	later: 'later',
	earlier: 'earlier',
	departures: 'Departures',
	switchToArrivals: 'Switch to arrivals',
	switchToDepartures: 'Switch to departures',
	track: 'Platform',
	platform: 'Platform',
	trackAbr: 'Pl.',
	platformAbr: 'Pl.',
	arrivalOnTrack: 'Arrival on track',
	tripIntermediateStops: (n: number) => {
		switch (n) {
			case 0:
				return 'No intermediate stops';
			case 1:
				return '1 intermediate stop';
			default:
				return `${n} intermediate stops`;
		}
	},
	sharingProvider: 'Provider',
	sharingProviders: 'Providers',
	returnOnlyAtStations: 'The vehicle must be returned at a station.',
	roundtripStationReturnConstraint: 'The vehicle must be returned to the departure station.',
	rentalStation: 'Station',
	rentalGeofencingZone: 'Zone',
	noItinerariesFound: 'No itineraries found.',
	advancedSearchOptions: 'Options',
	selectTransitModes: 'Select transit modes',
	defaultSelectedModes: 'All transit modes',
	defaultSelectedProviders: 'All providers',
	selectElevationCosts: 'Avoid steep incline.',
	useRoutedTransfers: 'Use routed transfers',
	wheelchair: 'Accessible transfers',
	bikeRental: 'Allow usage of sharing vehicles',
	requireBikeTransport: 'Bike carriage',
	requireCarTransport: 'Car carriage',
	considerRentalReturnConstraints: 'Return rental vehicles within journey',
	default: 'Default',
	timetableSources: 'Timetable sources',
	tripCancelled: 'Trip cancelled',
	stopCancelled: 'Stop cancelled',
	inOutDisallowed: 'Entry/exit not possible',
	inDisallowed: 'Entry not possible',
	outDisallowed: 'Exit not possible',
	unscheduledTrip: 'Additional service',
	alertsAvailable: 'Service alerts present',
	dataExpiredSince: 'Warning: Expired data, last valid',
	FLEX: 'On-Demand',
	WALK: 'Walking',
	BIKE: 'Bike',
	RENTAL: 'Sharing',
	CAR: 'Car',
	CAR_PARKING: 'Car Parking',
	CAR_DROPOFF: 'Drop-off (car)',
	TRANSIT: 'Transit',
	TRAM: 'Tram',
	SUBWAY: 'Subway',
	FERRY: 'Ferry',
	AIRPLANE: 'Airplane',
	SUBURBAN: 'Suburban Rail',
	BUS: 'Bus',
	COACH: 'Long Distance Bus / Coach',
	RAIL: 'Train',
	HIGHSPEED_RAIL: 'High Speed Rail',
	LONG_DISTANCE: 'Intercity Rail',
	NIGHT_RAIL: 'Night Rail',
	REGIONAL_FAST_RAIL: 'Fast Rail',
	REGIONAL_RAIL: 'Regional Rail',
	OTHER: 'Other',
	RENTAL_BICYCLE: 'Shared bike',
	RENTAL_CARGO_BICYCLE: 'Shared cargo bike',
	RENTAL_CAR: 'Shared car',
	RENTAL_MOPED: 'Shared moped',
	RENTAL_SCOOTER_STANDING: 'Shared standing scooter',
	RENTAL_SCOOTER_SEATED: 'Shared seated scooter',
	RENTAL_OTHER: 'Other shared vehicle',
	CABLE_CAR: 'Cable car',
	FUNICULAR: 'Funicular',
	AERIAL_LIFT: 'Aerial lift',
	routingSegments: {
		maxTransfers: 'Max. transfers',
		maxTravelTime: 'Max. travel time',
		firstMile: 'First mile',
		lastMile: 'Last mile',
		direct: 'Direct connection',
		maxPreTransitTime: 'Max. pre-transit time',
		maxPostTransitTime: 'Max. post-transit time',
		maxDirectTime: 'Max. direct time'
	},
	elevationCosts: {
		NONE: 'No detours',
		LOW: 'Small detours',
		HIGH: 'Large detours'
	},
	isochrones: {
		title: 'Isochrones',
		displayLevel: 'Display level',
		maxComputeLevel: 'Max. computation level',
		canvasRects: 'Rects (Overlay)',
		canvasCircles: 'Circles (Overlay)',
		geojsonCircles: 'Circles (Geometry)',
		styling: 'Isochrones styling',
		noData: 'No data',
		requestFailed: 'Request failed'
	},
	alerts: {
		validFrom: 'Valid from',
		until: 'until',
		information: 'Information',
		more: 'more'
	},
	incline: 'Incline',
	toll: 'Warning! A fee must be paid to use this route.',
	accessRestriction: 'No access',
	continuesAs: 'Continues as',
	rent: 'Rent',
	copyToClipboard: 'Copy to clipboard',
	rideThroughAllowed: 'Riding through allowed',
	rideThroughNotAllowed: 'Riding through not allowed',
	rideEndAllowed: 'Parking allowed',
	rideEndNotAllowed: 'Parking only at stations'
};

export default translations;
